import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { callAPI } from 'helpers';
import { isApplyExamCardVisible } from 'apply-exam-window';

// Components
import { Link } from 'react-router-dom';

// Hooks
import { useSelector } from 'react-redux';

// กล่องสมัครสอบบน Dashboard (TGAT/TPAT, A-Level) — โชว์ตั้งแต่วันเปิด (enabled.json start) เทียบ timestamp จาก API
// หลังปิดรับยังค้าง: หน้าสรุปจัดการสถานะเอง (ช่วงสมัครล่าช้า +200 บาท / หมดเวลา) — src/late-fee.js
// prod/staging ใช้ logic เดียวกัน: staging เปิดดูก่อนวันจริงด้วย ?now= · gate การยืนยันจริงอยู่ที่ BE timewindows
const ApplyExamCard = ({ examKey, windowKey, title, details }) => {
  const profile = useSelector((state) => _.get(state, 'app.user') || {});
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let active = true;
    const fetchTimestamp = async () => {
      try {
        const { result } = await callAPI({ url: `/applicants/me/apply-exam-summary/${examKey}` });
        if (active) setVisible(isApplyExamCardVisible(windowKey, result.timestamp));
      } catch (error) {
        console.log({ error });
      }
    };
    fetchTimestamp();
    return () => { active = false; };
  }, [examKey, windowKey]);

  if (!visible) return null;
  return (
    <div className='t-box -exam'>
      <h2 className='title'>{title}</h2>
      <div>
        <p>
          {details.map((line, index) => (
            <React.Fragment key={line}>
              {Boolean(index) && <br />}
              {line}
            </React.Fragment>
          ))}
        </p>
        {!profile.picture ? (
          <p className='color-orange'>
            {'กรุณาอัปโหลดรูปถ่ายผู้สมัคร เพื่อทำการสมัครสอบ'}
            <br />
            {'สามารถแก้ไขได้ที่หน้า ข้อมูลการลงทะเบียน'}
          </p>
        ) : !profile.program_code ? (
          <p className='color-orange'>
            {'กรุณากรอกข้อมูลหลักสูตรการศึกษา เพื่อทำการสมัครสอบ'}
            <br />
            {'สามารถแก้ไขได้ที่หน้า ข้อมูลการลงทะเบียน'}
          </p>
        ) : !profile.school_year ? (
          <p className='color-orange'>
            {'กรุณากรอกข้อมูลปีการศึกษา เพื่อทำการสมัครสอบ'}
            <br />
            {'สามารถแก้ไขได้ที่หน้า ข้อมูลการลงทะเบียน'}
          </p>
        ) : null}
        {(profile.picture && profile.program_code && profile.school_year) ? (
          <Link to={`/profile/apply-exams/${examKey}`} className='btn-main'>
            {'ดูรายละเอียดและสมัครสอบ'}
          </Link>
        ) : null}
      </div>
    </div>
  );
};

export default ApplyExamCard;
